import axios from "axios";
import {
  getFirstDateOfCurrentMonth,
  getLastDateOfCurrentMonth,
} from "@components/Common/Function";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const getWssDarpanSyncDaysExceptionApi = async (SH_Code__c, Title) => {
  const currentMonthLastDate = getLastDateOfCurrentMonth();
  const currentMonthFirstDate = getFirstDateOfCurrentMonth();

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/wss/get-wss-darpan-sync-days-exception`,
    method: "post",
    headers: headers,
    data: { currentMonthLastDate, currentMonthFirstDate, SH_Code__c, Title },
  };

  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
